import { createFileRoute } from '@tanstack/react-router';

import { EncounterDetailPage } from '@/features/emr/pages/EncounterDetailPage';

export const Route = createFileRoute('/_authenticated/encounters/$encounterId')({
  component: EncounterDetailPage,
  beforeLoad: () => ({
    breadcrumbs: [
      { href: '/encounters', title: 'Encounters' },
      { title: 'Encounter' },
    ],
  }),
});
